<ng-select [items]="items$ | async"
           [multiple]="multiple"
           [placeholder]="placeholder"
           [typeahead]="input$"
           [(ngModel)]="selectedItems"
           [loading]="isLoading"
           (ngModelChange)="valueChanged($event)">
</ng-select>
